import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 px-6 bg-sage relative overflow-hidden" data-id="element-86">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl text-center border-t-8 border-terracotta" data-id="element-88">
          <div className="inline-block bg-red-100 text-red-600 font-bold px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-89">
            OFERTA DE LANZAMIENTO
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest mb-4" data-id="element-90">
            Llevate el Método Freezer-Fit + Los Checklists de compras
          </h2>

          <p className="text-brown mb-8 text-lg" data-id="element-91">Por un único pago de:</p>

          <div className="flex justify-center items-baseline mb-2" data-id="element-92">
            <span className="text-3xl font-bold text-forest mr-2" data-id="element-93">$</span>
            <span className="text-6xl md:text-7xl font-bold text-forest tracking-tight" data-id="element-94">
              14.900
            </span>
            <span className="text-xl font-bold text-forest ml-2" data-id="element-95">ARS</span>
          </div>

          <p className="text-terracotta font-bold mb-10 italic" data-id="element-96">
            (Menos de lo que te sale un solo delivery de pizza hoy).
          </p>

          <Button className="w-full md:w-auto text-xl py-5 px-10 mb-6 shadow-terracotta/30 shadow-xl" data-id="element-97">
            QUIERO MI PLAN DE VIANDAS AHORA
          </Button>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-500 mt-4" data-id="element-98">
            <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-99" />
            <span data-id="element-100">
              Acceso inmediato en PDF después de la compra. Pago seguro.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}